import { useMutation } from '@apollo/client'
import { DeletePositionDocument } from 'generated/resources/graphql'

export const useDeletePosition = () => {
  const [deletePosition, { loading }] = useMutation(DeletePositionDocument)

  return {
    loading,
    delete(id: string) {
      return deletePosition({
        variables: { id },
      })
    },
  }
}
